import { render } from "./developCenter.vue?vue&type=template&id=e6561582&scoped=true"
import script from "./developCenter.vue?vue&type=script&lang=js"
export * from "./developCenter.vue?vue&type=script&lang=js"

import "./developCenter.vue?vue&type=style&index=0&id=e6561582&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6561582"]])

export default __exports__